import type {PublicMethodDefinition, PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {extensionPublicAPI, deprecate} = publicMethodUtils

    const desperadoDeprecado = (func: PublicMethodDefinition, newFunctionName: string) =>
        deprecate(
            func,
            `This method is deprecated. Please use global.cssStyle.${newFunctionName} instead. This method will be removed by 10/8/25`
        )

    return {
        methods: {
            global: {
                styles: {
                    create: desperadoDeprecado(
                        extensionPublicAPI.dataManipulation('style.global.create', {
                            getReturnValueMethodPath: 'style.global.getNewGlobalStylePointer'
                        }),
                        'create'
                    ),
                    update: desperadoDeprecado(extensionPublicAPI.dataManipulation('style.global.update'), 'update'),
                    isGlobalStyle: desperadoDeprecado(
                        extensionPublicAPI.getter('style.global.isGlobalStyle'),
                        'isGlobalStyle'
                    ),
                    remove: desperadoDeprecado(extensionPublicAPI.dataManipulation('style.global.delete'), 'delete'),
                    replace: desperadoDeprecado(extensionPublicAPI.dataManipulation('style.global.replace'), 'replace'),
                    get: desperadoDeprecado(extensionPublicAPI.getter('style.global.get'), 'get'),
                    getAll: desperadoDeprecado(extensionPublicAPI.getter('style.global.getAll'), 'getAll')
                },
                cssStyle: {
                    create: extensionPublicAPI.dataManipulation('style.global.create', {
                        getReturnValueMethodPath: 'style.global.getNewGlobalStylePointer'
                    }),
                    get: extensionPublicAPI.getter('style.global.get'),
                    update: extensionPublicAPI.dataManipulation('style.global.update'),
                    remove: extensionPublicAPI.dataManipulation('style.global.remove'),
                    delete: extensionPublicAPI.dataManipulation('style.global.delete'),
                    isGlobalStyle: extensionPublicAPI.getter('style.global.isGlobalStyle'),
                    replace: extensionPublicAPI.dataManipulation('style.global.replace'),
                    getAll: extensionPublicAPI.getter('style.global.getAll')
                }
            }
        }
    }
}
